var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: 526484,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.02295 20H16.9785C18.4415 20 19.6304 18.8111 19.6304 17.3481V4.13331C19.6304 2.67035 18.4415 1.48145 16.9785 1.48145H15.9267V0.740727C15.9267 0.333315 15.5933 0 15.1859 0C14.7785 0 14.4452 0.333315 14.4452 0.740727V1.48145H5.55631V0.740727C5.55631 0.333315 5.22293 0 4.81552 0C4.40811 0 4.07479 0.333315 4.07479 0.740727V1.48145H3.02295C1.55999 1.48145 0.371094 2.67035 0.371094 4.13331V17.3481C0.371094 18.8111 1.55999 20 3.02295 20ZM1.85261 4.13331C1.85261 3.48889 2.37853 2.96297 3.02295 2.96297H4.07479V3.7037C4.07479 4.11111 4.40811 4.44442 4.81552 4.44442C5.22293 4.44442 5.55624 4.11111 5.55624 3.7037V2.96297H14.4452V3.7037C14.4452 4.11111 14.7785 4.44442 15.1859 4.44442C15.5933 4.44442 15.9266 4.11111 15.9266 3.7037V2.96297H16.9784C17.6229 2.96297 18.1488 3.48889 18.1488 4.13331V17.3481C18.1488 17.9926 17.6229 18.5185 16.9784 18.5185H3.02295C2.37853 18.5185 1.85261 17.9926 1.85261 17.3481V4.13331Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15C12.2091 15 14 13.2091 14 11C14 8.79086 12.2091 7 10 7C7.79086 7 6 8.79086 6 11C6 13.2091 7.79086 15 10 15Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDay);
export default __webpack_public_path__ + "static/media/calendar-day.7499ad0f71c8f52dd2a42a2c9f89a3aa.svg";
export { ForwardRef as ReactComponent };